import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=c1672450&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=c1672450&prod&lang=css"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=c1672450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1672450",
  null
  
)

export default component.exports